import { productConstants } from '../constants';

const initialState = {
    list: [],
    detail: {},
    status: "",
    error: {},
};

export function product(state = initialState, action) {
    switch (action.type) {
        case productConstants.GET_PRODUCTS_OF_PUBLIC_SHOP_REQUEST:
            return {
              ...state,
              status: "GET_PRODUCTS_OF_PUBLIC_SHOP_REQUEST"
            }
        case productConstants.GET_PRODUCTS_OF_PUBLIC_SHOP_SUCCESS:
          return {
            ...state,
            list: action.payload || [],
            status: "GET_PRODUCTS_OF_PUBLIC_SHOP_SUCCESS"
          }
        case productConstants.GET_PRODUCTS_OF_PUBLIC_SHOP_ERROR:
          return {
            ...state,
            list: [],
            error: action.payload,
            status: "GET_PRODUCTS_OF_PUBLIC_SHOP_ERROR"
          }
        default:
            return state
    }
};